"use client"

import { ChevronDown } from "lucide-react"

import { Avatar, AvatarFallback, AvatarImage } from "./components/ui/avatar"
import { Button } from "./components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./components/ui/card"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./components/ui/command"
import { Popover, PopoverContent, PopoverTrigger } from "./components/ui/popover"

const teamMembers = [
  {
    name: "김소연",
    email: "soyeon@example.com",
    avatar: "/avatars/01.png",
    role: "관리자",
  },
  {
    name: "이준혁",
    email: "junhyuk@example.com",
    avatar: "/avatars/02.png",
    role: "개발자",
  },
  {
    name: "박서윤",
    email: "seoyoon@example.com",
    avatar: "/avatars/03.png",
    role: "정산",
  },
]

const roles = [
  {
    name: "뷰어",
    description: "보기 및 댓글 작성 가능",
  },
  {
    name: "개발자",
    description: "보기, 댓글 및 편집 가능",
  },
  {
    name: "정산",
    description: "보기, 댓글 및 정산 관리 가능",
  },
  {
    name: "관리자",
    description: "모든 리소스에 대한 관리자 권한",
  },
]

export function CardsTeamMembers() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>팀 멤버</CardTitle>
        <CardDescription>팀원을 초대하여 협업하세요.</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-6">
        {teamMembers.map((member) => (
          <div key={member.name} className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <Avatar className="border">
                <AvatarImage src={member.avatar || "/placeholder.svg"} alt="Image" />
                <AvatarFallback>{member.name.charAt(0)}</AvatarFallback>
              </Avatar>
              <div className="flex flex-col gap-0.5">
                <p className="text-sm leading-none font-medium">{member.name}</p>
                <p className="text-muted-foreground text-xs">{member.email}</p>
              </div>
            </div>
            <Popover>
              <PopoverTrigger asChild>
                <Button variant="outline" size="sm" className="ml-auto shadow-none bg-transparent">
                  {member.role} <ChevronDown />
                </Button>
              </PopoverTrigger>
              <PopoverContent className="p-0" align="end">
                <Command>
                  <CommandInput placeholder="역할 선택..." />
                  <CommandList>
                    <CommandEmpty>역할을 찾을 수 없습니다.</CommandEmpty>
                    <CommandGroup>
                      {roles.map((role) => (
                        <CommandItem key={role.name}>
                          <div className="flex flex-col">
                            <p className="text-sm font-medium">{role.name}</p>
                            <p className="text-muted-foreground">{role.description}</p>
                          </div>
                        </CommandItem>
                      ))}
                    </CommandGroup>
                  </CommandList>
                </Command>
              </PopoverContent>
            </Popover>
          </div>
        ))}
      </CardContent>
    </Card>
  )
}
